// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"36f2560b","622":"ba26530f"}[chunkId] + ".chunk.js";
};